import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
})
export class TextareaComponent implements OnDestroy {
  @Input() label!: string;
  @Input() control!: FormControl;
  @Input() error: string | null = '';
  @Output() blurEvent = new EventEmitter<void>();
  debouncer = new Subject<void>();
  subs = new Array<Subscription>();

  constructor() {
    this.subs.push(this.debouncer
      .pipe(debounceTime(200))
      .subscribe((_) => this.blurEvent.emit())
    );
  }

  ngOnDestroy(): void {
    this.subs.map(s => s.unsubscribe());
  }

  onBlur(): void {
    this.debouncer.next();
  }
}
